import React from "react";

export default function Dashboard() {
  return (
    <app-dashboard _nghost-ng-c856661959="" className="ng-star-inserted">
      <div _ngcontent-ng-c856661959="" className="animated fadeIn divider-top">
        <div _ngcontent-ng-c856661959="" className="row">
          <div _ngcontent-ng-c856661959="" className="col-sm-12 col-md-6">
            <div
              _ngcontent-ng-c856661959=""
              className="card card-accent-primary"
            >
              <div
                _ngcontent-ng-c856661959=""
                className="card-header account-detail-head"
              >
                {" "}
                Live Sports Profit
              </div>
              <div
                _ngcontent-ng-c856661959=""
                className="card-body account-stat-body"
                style={{ padding: 0 }}
              >
                <div _ngcontent-ng-c856661959="" className="row">
                  <div _ngcontent-ng-c856661959="" className="col-md-12">
                    <div
                      _ngcontent-ng-c856661959=""
                      id="live"
                      style={{ width: "100%" }}
                    >
                      <div
                        data-highcharts-chart={5}
                        style={{ overflow: "hidden" }}
                      >
                        <div
                          id="highcharts-iwbyh9f-34"
                          dir="ltr"
                          style={{
                            position: "relative",
                            overflow: "hidden",
                            width: 387,
                            height: 400,
                            textAlign: "left",
                            lineHeight: "normal",
                            zIndex: 0,
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            userSelect: "none",
                            touchAction: "manipulation",
                            outline: "none",
                          }}
                          className="highcharts-container "
                        >
                          <svg
                            version="1.1"
                            className="highcharts-root"
                            style={{
                              fontFamily: "Helvetica, Arial, sans-serif",
                              fontSize: "1rem",
                              marginLeft: "45px",
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width={387}
                            height={400}
                            viewBox="0 0 387 400"
                            role="img"
                            aria-label=""
                          >
                            <desc>Created with Highcharts 11.1.0</desc>
                            <defs>
                              <filter id="highcharts-drop-shadow-5">
                                <feDropShadow
                                  dx={1}
                                  dy={1}
                                  floodColor="#000000"
                                  floodOpacity="0.75"
                                  stdDeviation="2.5"
                                />
                              </filter>
                              <clipPath id="highcharts-iwbyh9f-37-">
                                <rect
                                  x={0}
                                  y={0}
                                  width={367}
                                  height={375}
                                  fill="none"
                                />
                              </clipPath>
                            </defs>
                            <rect
                              fill="#ffffff"
                              className="highcharts-background"
                              filter="none"
                              x={0}
                              y={0}
                              width={387}
                              height={400}
                              rx={0}
                              ry={0}
                            />
                            <rect
                              fill="none"
                              className="highcharts-plot-background"
                              x={10}
                              y={10}
                              width={367}
                              height={375}
                              filter="url(#highcharts-drop-shadow-5)"
                            />
                            <rect
                              fill="none"
                              className="highcharts-plot-border"
                              data-z-index={1}
                              stroke="#cccccc"
                              strokeWidth={0}
                              x={10}
                              y={10}
                              width={367}
                              height={375}
                            />
                            <g
                              className="highcharts-series-group"
                              data-z-index={3}
                              filter="none"
                            >
                              <g
                                className="highcharts-series highcharts-series-0 highcharts-pie-series highcharts-tracker"
                                data-z-index="0.1"
                                opacity={1}
                                transform="translate(10,10) scale(1 1)"
                                filter="none"
                                clipPath="none"
                                style={{ cursor: "pointer" }}
                              >
                                <path
                                  fill="#2caffe"
                                  d="M 183.4705755655138 43.031148221484585 A 3 3 0 0 1 186.5322483511088 40.03117119222381 A 147.5 147.5 0 0 1 217.8491586013658 44.055288339450385 A 3 3 0 0 1 220.05291800411212 47.73185561300224 L 183.5 187.5 A 0 0 0 0 1 183.5 187.5 A 0 0 0 0 0 183.5 187.5 A 0 0 0 0 1 183.5 187.5 Z"
                                  transform="translate(0,0)"
                                  stroke="#ffffff"
                                  strokeWidth={1}
                                  opacity={1}
                                  strokeLinejoin="round"
                                  className="highcharts-point highcharts-color-0"
                                />
                                <path
                                  fill="#544fc5"
                                  d="M 220.19266784874694 47.76847840898054 A 3 3 0 0 1 223.91632056629183 45.645246706771445 A 147.5 147.5 0 1 1 180.23288883431658 40.03618754205809 A 3 3 0 0 1 183.29933565904133 43.03128458443928 L 183.5 187.5 A 0 0 0 0 1 183.5 187.5 A 0 0 0 1 0 183.5 187.5 A 0 0 0 0 1 183.5 187.5 Z"
                                  transform="translate(0,0)"
                                  stroke="#ffffff"
                                  strokeWidth={1}
                                  opacity={1}
                                  strokeLinejoin="round"
                                  className="highcharts-point highcharts-color-1"
                                />
                              </g>
                              <g
                                className="highcharts-markers highcharts-series-0 highcharts-pie-series"
                                data-z-index="0.1"
                                opacity={1}
                                transform="translate(10,10) scale(1 1)"
                                clipPath="none"
                              />
                            </g>
                            <text
                              x={194}
                              textAnchor="middle"
                              className="highcharts-title"
                              data-z-index={4}
                              style={{
                                fontSize: "1.2em",
                                color: "rgb(51, 51, 51)",
                                fontWeight: "bold",
                                fill: "rgb(51, 51, 51)",
                              }}
                              y={25}
                            />
                            <text
                              x={194}
                              textAnchor="middle"
                              className="highcharts-subtitle"
                              data-z-index={4}
                              style={{
                                color: "rgb(102, 102, 102)",
                                fontSize: "0.8em",
                                fill: "rgb(102, 102, 102)",
                              }}
                              y={24}
                            />
                            <text
                              x={10}
                              textAnchor="start"
                              className="highcharts-caption"
                              data-z-index={4}
                              style={{
                                color: "rgb(102, 102, 102)",
                                fontSize: "0.8em",
                                fill: "rgb(102, 102, 102)",
                              }}
                              y={397}
                            />
                            <g
                              className="highcharts-data-labels highcharts-series-0 highcharts-pie-series highcharts-tracker"
                              data-z-index={6}
                              opacity={1}
                              transform="translate(10,10) scale(1 1)"
                              style={{ cursor: "pointer" }}
                            >
                              <path
                                fill="none"
                                className="highcharts-data-label-connector highcharts-color-0"
                                strokeWidth={1}
                                stroke="#2caffe"
                                d="M 211.18466025129248 11.455527808217091 L 206.1846602512927 11.455527808217091 L 203.1174385835122 35.25872404823281 L 202.35063316656712 41.20952310823674"
                              />
                              <path
                                fill="none"
                                className="highcharts-data-label-connector highcharts-color-1"
                                strokeWidth={1}
                                stroke="#544fc5"
                                d="M 155.81533974870752 363.5444721917829 L 160.81533974870743 363.5444721917829 L 163.88256141648787 339.7412759517672 L 164.64936683343296 333.79047689176326"
                              />
                              <g
                                className="highcharts-label highcharts-data-label highcharts-data-label-color-0"
                                data-z-index={1}
                                filter="none"
                                style={{ cursor: "pointer" }}
                                transform="translate(216,0)"
                              >
                                <text
                                  x={5}
                                  data-z-index={1}
                                  y={16}
                                  style={{
                                    color: "rgb(0, 0, 0)",
                                    fontSize: "0.7em",
                                    fontWeight: "bold",
                                    fill: "rgb(0, 0, 0)",
                                  }}
                                >
                                  <tspan
                                    className="highcharts-text-outline"
                                    fill="#FFFFFF"
                                    stroke="#FFFFFF"
                                    strokeWidth="2px"
                                    strokeLinejoin="round"
                                  >
                                    <tspan style={{ fontWeight: "bold" }}>
                                      Casino
                                    </tspan>
                                    : 0
                                    <tspan x={5} dy={0}>
                                      ​
                                    </tspan>
                                  </tspan>
                                  <tspan style={{ fontWeight: "bold" }}>
                                    Casino
                                  </tspan>
                                  : 0
                                </text>
                              </g>
                              <g
                                className="highcharts-label highcharts-data-label highcharts-data-label-color-1"
                                data-z-index={1}
                                filter="none"
                                style={{ cursor: "pointer" }}
                                transform="translate(56,352)"
                              >
                                <text
                                  x={5}
                                  data-z-index={1}
                                  y={16}
                                  style={{
                                    color: "rgb(0, 0, 0)",
                                    fontSize: "0.7em",
                                    fontWeight: "bold",
                                    fill: "rgb(0, 0, 0)",
                                  }}
                                >
                                  <tspan
                                    className="highcharts-text-outline"
                                    fill="#FFFFFF"
                                    stroke="#FFFFFF"
                                    strokeWidth="2px"
                                    strokeLinejoin="round"
                                  >
                                    <tspan style={{ fontWeight: "bold" }}>
                                      Cricket
                                    </tspan>
                                    :0
                                    <tspan x={5} dy={0}>
                                      ​
                                    </tspan>
                                  </tspan>
                                  <tspan style={{ fontWeight: "bold" }}>
                                    Cricket
                                  </tspan>
                                  : 0
                                </text>
                              </g>
                            </g>
                            <g
                              className="highcharts-legend highcharts-no-tooltip"
                              data-z-index={7}
                              visibility="hidden"
                            >
                              <rect
                                fill="none"
                                className="highcharts-legend-box"
                                rx={0}
                                ry={0}
                                stroke="#999999"
                                strokeWidth={0}
                                filter="none"
                                x={0}
                                y={0}
                                width={8}
                                height={8}
                              />
                              <g data-z-index={1}>
                                <g />
                              </g>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div _ngcontent-ng-c856661959="" className="col-sm-12 col-md-6">
            <div
              _ngcontent-ng-c856661959=""
              className="card card-accent-primary"
            >
              <div
                _ngcontent-ng-c856661959=""
                className="card-header account-detail-head"
              >
                {" "}
                Backup Sports Profit
              </div>
              <div
                _ngcontent-ng-c856661959=""
                className="card-body account-stat-body"
                style={{ padding: 0 }}
              >
                <div _ngcontent-ng-c856661959="" className="row">
                  <div _ngcontent-ng-c856661959="" className="col-md-12">
                    <div
                      _ngcontent-ng-c856661959=""
                      id="Backup"
                      style={{ width: "100%" }}
                    >
                      <div
                        id="highcharts-iwbyh9f-27"
                        dir="ltr"
                        style={{
                          position: "relative",
                          overflow: "hidden",
                          width: 387,
                          height: 400,
                          textAlign: "left",
                          lineHeight: "normal",
                          zIndex: 0,
                          WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                          userSelect: "none",
                          touchAction: "manipulation",
                          outline: "none",
                        }}
                        className="highcharts-container "
                      >
                        <svg
                          version="1.1"
                          className="highcharts-root"
                          style={{
                            fontFamily: "Helvetica, Arial, sans-serif",
                            fontSize: "1rem",
                            marginLeft: "20px",
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width={387}
                          height={400}
                          viewBox="0 0 387 400"
                          role="img"
                          aria-label=""
                        >
                          <desc>Created with Highcharts 11.1.0</desc>
                          <defs>
                            <filter id="highcharts-drop-shadow-4">
                              <feDropShadow
                                dx={1}
                                dy={1}
                                floodColor="#000000"
                                floodOpacity="0.75"
                                stdDeviation="2.5"
                              />
                            </filter>
                            <clipPath id="highcharts-iwbyh9f-33-">
                              <rect
                                x={0}
                                y={0}
                                width={367}
                                height={375}
                                fill="none"
                              />
                            </clipPath>
                          </defs>
                          <rect
                            fill="#ffffff"
                            className="highcharts-background"
                            filter="none"
                            x={0}
                            y={0}
                            width={387}
                            height={400}
                            rx={0}
                            ry={0}
                          />
                          <rect
                            fill="none"
                            className="highcharts-plot-background"
                            x={10}
                            y={10}
                            width={367}
                            height={375}
                            filter="url(#highcharts-drop-shadow-4)"
                          />
                          <rect
                            fill="none"
                            className="highcharts-plot-border"
                            data-z-index={1}
                            stroke="#cccccc"
                            strokeWidth={0}
                            x={10}
                            y={10}
                            width={367}
                            height={375}
                          />
                          <g
                            className="highcharts-series-group"
                            data-z-index={3}
                            filter="none"
                          >
                            <g
                              className="highcharts-series highcharts-series-0 highcharts-pie-series highcharts-tracker"
                              data-z-index="0.1"
                              opacity={1}
                              transform="translate(10,10) scale(1 1)"
                              filter="none"
                              clipPath="none"
                              style={{ cursor: "pointer" }}
                            >
                              <path
                                fill="#6b8abc"
                                d="M 183.46741530663746 14.01482720594882 A 0.014823200922973715 0.014823200922973715 0 0 1 183.48223686158693 14.000000986028397 A 160 160 0 1 1 183.262938650817 14.000175619106614 A 0.014823200922973715 0.014823200922973715 0 0 1 183.27778379999108 14.014978214630645 M 183.5 174 A 0 0 0 0 1 183.5 174 A 0 0 0 1 0 183.5 174"
                                transform="translate(0,0)"
                                stroke="#ffffff"
                                strokeWidth={1}
                                opacity={1}
                                strokeLinejoin="round"
                                className="highcharts-point highcharts-color-4"
                              />
                            </g>
                            <g
                              className="highcharts-markers highcharts-series-0 highcharts-pie-series"
                              data-z-index="0.1"
                              opacity={1}
                              transform="translate(10,10) scale(1 1)"
                              clipPath="none"
                            />
                          </g>
                          <text
                            x={194}
                            textAnchor="middle"
                            className="highcharts-title"
                            data-z-index={4}
                            style={{
                              fontSize: "1.2em",
                              color: "rgb(51, 51, 51)",
                              fontWeight: "bold",
                              fill: "rgb(51, 51, 51)",
                            }}
                            y={25}
                          />
                          <text
                            x={194}
                            textAnchor="middle"
                            className="highcharts-subtitle"
                            data-z-index={4}
                            style={{
                              color: "rgb(102, 102, 102)",
                              fontSize: "0.8em",
                              fill: "rgb(102, 102, 102)",
                            }}
                            y={24}
                          />
                          <text
                            x={10}
                            textAnchor="start"
                            className="highcharts-caption"
                            data-z-index={4}
                            style={{
                              color: "rgb(102, 102, 102)",
                              fontSize: "0.8em",
                              fill: "rgb(102, 102, 102)",
                            }}
                            y={397}
                          />
                          <g
                            className="highcharts-data-labels highcharts-series-0 highcharts-pie-series highcharts-tracker"
                            data-z-index={6}
                            opacity={1}
                            transform="translate(10,10) scale(1 1)"
                            style={{ cursor: "pointer" }}
                          >
                            <path
                              fill="none"
                              className="highcharts-data-label-connector highcharts-color-4"
                              strokeWidth={1}
                              stroke="#6b8abc"
                              d="M 188.5 364 L 183.5 364 L 183.5 340 L 183.5 334"
                            />
                            <g
                              className="highcharts-label highcharts-data-label highcharts-data-label-color-4"
                              data-z-index={1}
                              filter="none"
                              style={{ cursor: "pointer" }}
                              transform="translate(194,353)"
                            >
                              <text
                                x={5}
                                data-z-index={1}
                                y={16}
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  fontSize: "0.7em",
                                  fontWeight: "bold",
                                  fill: "rgb(0, 0, 0)",
                                }}
                              >
                                <tspan
                                  className="highcharts-text-outline"
                                  fill="#FFFFFF"
                                  stroke="#FFFFFF"
                                  strokeWidth="2px"
                                  strokeLinejoin="round"
                                >
                                  <tspan style={{ fontWeight: "bold" }}>
                                    Basketball
                                  </tspan>
                                  : 0
                                  <tspan x={5} dy={0}>
                                    ​
                                  </tspan>
                                </tspan>
                                <tspan style={{ fontWeight: "bold" }}>
                                  Basketball
                                </tspan>
                                : 0
                              </text>
                            </g>
                          </g>
                          <g
                            className="highcharts-legend highcharts-no-tooltip"
                            data-z-index={7}
                            visibility="hidden"
                          >
                            <rect
                              fill="none"
                              className="highcharts-legend-box"
                              rx={0}
                              ry={0}
                              stroke="#999999"
                              strokeWidth={0}
                              filter="none"
                              x={0}
                              y={0}
                              width={8}
                              height={8}
                            />
                            <g data-z-index={1}>
                              <g />
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-dashboard>
  );
}
